import { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      api.get("/auth/me")
        .then((r) => setUser(r.data))
        .catch(() => localStorage.removeItem("userToken"))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("userToken", r.data.token);
    setUser(r.data.user);
    // Refresh the full profile (/auth/me) so derived fields like
    // wishlist_course_ids are present immediately after login.
    api.get("/auth/me").then((me) => setUser(me.data)).catch(() => {});
    return r.data;
  };

  const register = async (email, password, name, phone) => {
    const r = await api.post("/auth/register", { email, password, name, phone });
    localStorage.setItem("userToken", r.data.token);
    setUser(r.data.user);
    return r.data;
  };

  const loginWithToken = (token, userData) => {
    localStorage.setItem("userToken", token);
    setUser(userData);
    api.get("/auth/me").then((me) => setUser(me.data)).catch(() => {});
  };

  const logout = () => {
    localStorage.removeItem("userToken");
    setUser(null);
  };

  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, loginWithToken, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
